module.exports = __webpack_public_path__ + "static/media/how-is-it-used-table.898bcdc4.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./public/how-is-it-used-table.gif
 ** module id = 434
 ** module chunks = 0
 **/